export const blockIconsCommunicationContactPhoneNew = (
	<span className='material-symbols-outlined'>contact_phone</span>
);
